export enum Servers {
  PRODUCTION = 'ascc.als.lbl.gov',
  PREPROD = 'ascc-stg.als.lbl.gov:800',
  STAGING = 'ascc-stg.als.lbl.gov',
  DEVELOPMENT = 'ascc-dev.als.lbl.gov',
  LOCAL = 'localhost'
}
